
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import CategoriesPage from '../pages/categories/page';
import CartPage from '../pages/cart/page';
import CheckoutPage from '../pages/checkout/page';
import OrderConfirmationPage from '../pages/order-confirmation/page';
import OrdersPage from '../pages/orders/page';
import ProductPage from '../pages/product/page';
import ProductDetailPage from '../pages/product/[id]/page';
import ProfilePage from '../pages/profile/page';
import NotFoundPage from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/categories',
    element: <CategoriesPage />,
  },
  {
    path: '/cart',
    element: <CartPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/order-confirmation',
    element: <OrderConfirmationPage />,
  },
  {
    path: '/orders',
    element: <OrdersPage />,
  },
  {
    path: '/product',
    element: <ProductPage />,
  },
  {
    path: '/product/:id',
    element: <ProductDetailPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
